import React, { useEffect, useState } from 'react';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import axios from 'axios';
import './InsurancesByMonth.scss';
import InsurancesByMonthPanoramicaPresentational from './InsurancesByMonthPanoramicaPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function InsurancesByMonthPanoramica(props) {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken } = {}] = useAuth();
  const { t } = useTranslation('DASHBOARD');
  const alert = useAlert();

  const [query, setQuery] = useQueryParams({
    offset: withDefault(NumberParam, 0),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    year: withDefault(NumberParam, new Date().getFullYear()),
    profileStatus: withDefault(StringParam),
  });

  const { offset, limit, year, profileStatus } = query;

  const fetchInsurancesPanoramica = async () => {
    showLoading();
    setData([]);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/insurances-by-month-panoramica`,
      {
        headers: { Authorization: newToken },
        params: { offset, limit, year, profileStatus },
      }
    );
    hideLoading();
    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    setData(response.data || []);
    setTotal(Number(response.headers['x-total-count']));
  };

  useEffect(() => {
    fetchInsurancesPanoramica();
  }, [offset, limit, year, profileStatus]);

  const onNoInsuranceConfirm = async ({ supplier, month, year }) => {
    showLoading();
    setData([]);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/insurances-by-month-panoramica/${supplier}`,
      { month, year },
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    await fetchInsurancesPanoramica();
  };

  function onFilter(queryDiff) {
    if (
      (query.profileStatus &&
        query.profileStatus !== queryDiff.profileStatus) ||
      (profileStatus && query.profileStatus === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  const onQueueJobRequestConfirm = async () => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/queueJobRequests`,
      {
        year,
        type: 'PANORAMICA_INVOICE_INSURANCES',
        business: 'PANORAMICA',
        service_type: 'insurances',
      },
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const notCreatedNew = response.data?.notCreatedNew;

    if (notCreatedNew === false) {
      alert.success('Richiesta rendicontazione creata correttamente');
    } else if (notCreatedNew === true) {
      alert.error(
        'Richiesta rendicontazione in stato "Non eseguita" giá presente. Richiesta non creata.'
      );
    }
    hideLoading();
  };

  return (
    <InsurancesByMonthPanoramicaPresentational
      data={data}
      total={total}
      query={query}
      onFilter={onFilter}
      onNoInsuranceConfirm={onNoInsuranceConfirm}
      fetchTotalInsurances={fetchInsurancesPanoramica}
      onQueueJobRequestConfirm={onQueueJobRequestConfirm}
      {...props}
    />
  );
}

export default InsurancesByMonthPanoramica;
